import React from "react"
import {WizardFormCheckBox} from "./WizardFormCheckBox";

export function WizardFormOption({data}) {
    return (
        <>
            <h3 className="mb-5 font-weight-bold text-dark">추가 옵션</h3>
            <div className="form-group">
                {/*{data.musthave === "Y" && <span className="text-danger">*</span>}<label>{`${data.name}`}</label>*/}
                {
                    data
                    .optionList
                    .map((wizardOptionItemData, i) =>
                        <WizardFormCheckBox data={wizardOptionItemData} key={"wizardOptionItem-" + i}/>)
                }
                {
                    data.optionList.length === 0 && <div>추가옵션은 없습니다.</div>
                }
            </div>
        </>
    )
}